// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"527":"43e66112","910":"5d1368c5"}[chunkId] + ".chunk.js";
};